const Resource = {
  lang: 'pt-br',
  text: {
    validations: {
      invalidUserPwdText: 'Nome de usuário ou senha inválidos',
    },
    values: {
      selectOneValueText: '--Selecione--',
    },
    screen: {
      login: {
        headerText: 'Simulcast Conecte-se',
        loginButtonText: 'Conecte-se',
        userNameLabel: 'Nome do usuário',
        passwordLabel: 'Senha',
        auctionLabelText: 'Escolha o Leilão',
        laneLabelText: 'Escolha a faixa',
        selectScreenHeaderText: 'Selecione uma tela',
        switchAuctionButtonText: 'Interruptor Leilão / Faixa',
        logoutButtonText: 'Sair',
      },
    },
  },
};

export default Resource;
